





















































import firebase from 'firebase/app'
import 'firebase/firestore'
import { includes } from 'ramda'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import {
  Vue, Component, Prop, Emit, Watch, Mixins,
} from 'vue-property-decorator'
import { db } from '../../firebase/init'
import store from '@/store'
import MainMixin from '../../mixins/MainMixin'
import { UserType, UserCollection } from '../../types'

@Component({
  components: {
  },
})
export default class UserAddNew extends Mixins(MainMixin) {
  showMap = ['searchForm']

  searchEmail = ''

  loading = false

  foundUser:UserType|null = null

  $refs:any

  name = {
    first: '',
    last: '',
  }

  isManager:boolean = false

  isMultiUser:boolean = false

  async findUser(email:string) {
    this.searchEmail = this.searchEmail.trim()
    this.loading = true
    const queryResult = await query(
      UserCollection,
      [where('email', '==', this.searchEmail.toLowerCase().trim())],
    )
    const result:UserType|null = queryResult.length > 0 ? queryResult[0].data : null
    console.log('inloc: ', result)
    this.foundUser = result
    if (this.foundUser) this.foundUser.id = queryResult[0].ref.id
    if (result && includes(this.Location.location, result.locations)) {
      this.showMap.push('userInLocation')
      if (result && includes(`${this.Location.location}-inactive`, result.authTags)) this.showMap.push('userInactive')
    } else if (result && !includes(this.Location.location, result.locations)) {
      console.log('ok')
      this.showMap.push('userInCanvas')
    } else {
      this.showMap.push('userIsNew')
    }
    this.loading = false
  }

  clearName() {
    this.name = {
      first: '',
      last: '',
    }
    this.isManager = false
    this.showMap = ['searchForm']
  }

  clearUser() {
    this.clearName()
    this.searchEmail = ''
    this.$refs.validation.reset()
  }

  async newUser() {
    this.loading = true
    console.log('loc: ', Location)
    const user:any = {
      firstName: this.name.first,
      lastName: this.name.last,
      email: this.searchEmail,
      phone: '',
      locations: [this.$store.getters.location],
      authTags: [this.$store.getters.location, this.$store.getters.group],
      multi: this.isMultiUser,
    }
    if (this.isManager) {
      user.authTags.push(`${this.$store.getters.group}-manager`)
    }
    user.email = user.email.toLowerCase()
    const result = await add(UserCollection, user)
    this.loading = false
    this.$toast.success(`User ${user.firstName} ${user.lastName} Successfully Added!`)
    this.clearUser()
    this.foundUser = Object.assign(result.data, { id: result.ref.id })
    this.showMap.push('userAdded')
  }

  async addToLocation() {
    if (!this.foundUser) return false
    this.loading = true
    console.log('loc: ', Location)
    await db.collection('users').doc(this.foundUser.id).update({
      locations: firebase.firestore.FieldValue.arrayUnion(this.$store.getters.location),
      authTags: firebase.firestore.FieldValue.arrayUnion(this.$store.getters.location),
    })
    this.loading = false
    this.$toast.success(`User ${this.foundUser.firstName} ${this.foundUser.lastName} Successfully Added!`)
    this.clearUser()
    return this.showMap.push('userAdded')
  }

  @Emit()
  showUser(id:string) {
    console.log('opinging ', id)
    return id
  }
}

